export const xWebHost = 'x-web-host'
export const serviceClient = 'service-client'
export const serviceVersion = 'service-version'
export const ocpApimSubscriptionKey = 'Ocp-Apim-Subscription-Key'
export const baseSiteId = 'baseSiteId'
export const bannerId = 'bannerid'
export const browseMode = 'browse-mode'
